/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface StageMappingOverride {
  stage_id: string;
  remote_stage_id?: string | null;
  remote_stage_name?: string | null;
}
